import { render, staticRenderFns } from "./EvaluationForm.vue?vue&type=template&id=5967b22a&scoped=true"
import script from "./EvaluationForm.vue?vue&type=script&lang=js"
export * from "./EvaluationForm.vue?vue&type=script&lang=js"
import style0 from "./EvaluationForm.vue?vue&type=style&index=0&id=5967b22a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5967b22a",
  null
  
)

export default component.exports